<form [formGroup]="form" (submit)="onSubmit()" class="form">
  <div class="fields">
    <app-input-email-field
      [form]="form"
      [id]="'email'"
      [controlName]="'email'"
      [key]="'auth.recoverPassword.email'"
    ></app-input-email-field>
    <button type="submit" class="button button-primary" [disabled]="form.invalid" translate>auth.recoverPassword.button</button>
    <p class="recover-link" translate>auth.recoverPassword.message <a [routerLink]="['/login']" translate>auth.recoverPassword.canLogin</a></p>
  </div>
</form>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/recover-password/recover-password-form/recover-password-form.component.html